;(function($) {
    $(document).ready(function() {

        //main
        //nav menu mobile
        $(".toggle-nav").on("click", function() {
            $(".navigation-bar").toggleClass("open");
        });
        //header-search
        $(".header-search-toggle").on("click", function() {
            $(".header-search").toggleClass("open");

            return false;
        });

        if($("body").hasClass("page-template-default")) {
            //gallery
            $(".gallery").owlCarousel({
                items:1,
                loop:true,
                margin:0,
                nav:false,
                dots:true,
                autoplay:true
            });
        }

        //home page
        if($("body").hasClass("home")) {
            //slider home
            $(".home-featured-slider").owlCarousel({
                items:1,
                loop:true,
                margin:0,
                nav:false,
                dots:true,
                autoplay:true
            });

            //news carousel
            $("#home-news .owl-carousel").owlCarousel({
                loop:true,
                margin:60,
                nav:true,
                dots:false,
                items:3,
                slideBy:3,
                autoplay:true,
                autoplayHoverPause:true,
                navText : ['<span aria-label="Précédent"><i class="icon icon-slide-previous"></i></span>','<span aria-label="Suivant"><i class="icon icon-slide-next"></i></span>'],
                responsive:{
                    0:{
                        items:1,
                        slideBy:1
                    },
                    768:{
                        items:2,
                        slideBy:2
                    },
                    1199:{
                        items:3,
                        slideBy:3,
                        margin:30
                    }
                }
            });
            $("#home-video").each(function() {
                var $button = $(this).find(".icon-play");
                var $video = $(this).find('video');
                $button.on("click", function(event) {
                    event.preventDefault();
                    $button.hide();
                    $video.after(
                        $("<iframe />")
                            .addClass("embed-responsive-item")
                            .attr({
                                src: $video.data("url"),
                                frameborder: 0,
                                allow: "autoplay; encrypted-media",
                            })
                            .prop("allowfullscreen", true)
                    );
                });
            });
            $("#home-training").each(function() {
                var $section = $(this);
                var $thumbnail = $(this).find("img.training-thumbnail");
                var $background = $(this).find(".visual-formation");
                var $permalink = $(this).find("a.training-permalink");
                var $toggles = $section.find("a[data-color]");
                $toggles.on("click", function(event) {
                    if ($background.is(':visible')) {
                        event.preventDefault();
                        $toggles.removeClass("active");
                        $(this).addClass("active");
                        $section.attr("data-color", $(this).data("color"));
                        $thumbnail.attr("src", $(this).data("thumbnail"));
                        $background.css("background-image", "url(" + $(this).data("thumbnail") + ")");
                        $permalink.attr("href", $(this).data("permalink"));
                    }
                });
            });
            $("#home-about").each(function() {
                var $section = $(this);
                var $tabs = $section.find(".tabs .tab");
                var $contents = $section.find(".tab-content");
                $tabs.on("click", function(event) {
                    event.preventDefault();
                    $tabs.attr("data-active", "false");
                    $(this).attr("data-active", "true");
                    $contents
                        .hide()
                        .filter("[data-tab=" + $(this).data("tab") + "]")
                            .css("display", "block")
                            .show();
                });
            });
        }




    });

})(jQuery);